<template>
  <div class="tooltip-container" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <div class="tooltip-icon-wrapper" @click.stop="showTooltip">
      <IconQuestion ref="iconRef" />
      <div v-if="isTooltipVisible" :class="['triangle-wrapper', !isDevicePhone ? (isOutOfScreen ? 'triangle-wrapper-top' : 'triangle-wrapper-left') : 'triangle-wrapper-top']">
        <div :class="['triangle-clip', !isDevicePhone ? (isOutOfScreen ? 'triangle-top' : 'triangle-left') : 'triangle-top']" />
      </div>
    </div>
    <div
      v-if="isTooltipVisible"
      :class="['tooltip', isOutOfScreen ? 'tooltip-bottom' : 'tooltip-right']"
      ref="tooltipRef"
    >
      <div class="tooltip-content">
        <div class="tooltip-close" @click.stop="hideTooltip">
          <IconClose />
        </div>

        <div class="tooltip-scroll">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconQuestion from '@/components/Icons/IconQuestion.vue';
import IconClose from '@/components/Icons/IconClose.vue';

export default {
  name: 'Tooltip',
  components: {
    IconQuestion,
    IconClose,
  },
  data() {
    return {
      isTooltipVisible: false,
      isOutOfScreen: false,
      isDevicePhone: false,
    };
  },
  mounted() {
    this.checkDeviceType();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (this.isTooltipVisible) {
        this.isTooltipVisible = false;
        this.isOutOfScreen = false;
      }
      this.checkDeviceType();
    },
    placeTooltipUnderIcon() {
      const iconElement = this.$refs.iconRef.$el;
      const divElement = this.$refs.tooltipRef;

      const currentTop = divElement.style.top;
      const iconPos = iconElement.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.isDevicePhone) {
        divElement.style.top = `${iconPos.top + iconPos.height + scrollTop + 15}px`;
      } else {
        divElement.style.top = currentTop;
      }
    },
    checkDeviceType() {
      this.isDevicePhone = window.innerWidth < 730;
    },
    checkDivPosition() {
      const divElement = this.$refs.tooltipRef;

      if (!divElement) {
        return;
      }

      const divRect = divElement.getBoundingClientRect();
      const divEndPosition = divRect.left + divRect.width;

      const screenWidth = window.innerWidth || document.documentElement.clientWidth;
      const isEndOutOfScreen = (divEndPosition + 10) > screenWidth;

      if (isEndOutOfScreen !== this.isOutOfScreen) {
        this.isOutOfScreen = isEndOutOfScreen;
      }
    },
    showTooltip() {
      if (!this.isTooltipVisible) {
        this.isTooltipVisible = true;
        this.$nextTick(() => {
          this.checkDivPosition();
          this.placeTooltipUnderIcon();
        });
      }
    },
    hideTooltip() {
      this.isTooltipVisible = false;
      this.isOutOfScreen = false;
    },
  },
};
</script>
